export default "__VITE_PUBLIC_ASSET__0db0cd03__"